import SearchHead from "components/searchHead";
import { SEARCH_FORM_ID_ROOM_RESV } from "components/constent";
import { useTranslation } from "react-i18next";
import { SearchForm } from "./searchForm";
import ResvList from "./list";
import { ResvFilterProvider, ResvListProvider } from "./context";

export default function RoomResv() {
  const { t } = useTranslation();

  return (
    <>
      <SearchHead
        title={t("sub_ttl_resv")}
        formId={SEARCH_FORM_ID_ROOM_RESV}
        onClick={() => {}}
      />

      <ResvListProvider>
        <ResvFilterProvider>
          <SearchForm />
        </ResvFilterProvider>
        <ResvList />
      </ResvListProvider>
    </>
  );
}
